// extracted by mini-css-extract-plugin
export default {"block":"EPriceTimesLegend_block__fVpFT","item":"EPriceTimesLegend_item__80qF6","pipe":"EPriceTimesLegend_pipe__-2MOE","txt":"EPriceTimesLegend_txt__0XsoX"};